import { BaseManager } from '../core/baseManager';
import { windowScope } from '../window/windowScope';
import { Logger } from '../utils/logger';

export class SearchManager extends BaseManager {

    constructor() {
        super('SearchManager');
        this.logger = new Logger();
    }

    public initialize(): void {
        super.initialize();
        this.setupSearchFunctionality();
    }

    private setupSearchFunctionality(): void {
        // copy search model (hidden inputs) form desktop searchbox over to MobileSearchFields.cshtml output
        const hiveMenuSearch = document.querySelector('[data-hive-menu-search]') as HTMLElement;
        const droneMenuSearch = document.querySelector('[data-drone-menu-search]') as HTMLElement;

        Array.from(hiveMenuSearch.children)
            .filter((child): child is HTMLInputElement => child.tagName.toLowerCase() === 'input')
            .forEach(input => {
                const clonedInput = input.cloneNode(true) as HTMLInputElement;
                if (clonedInput.getAttribute('data-sf-role') === 'searchTextBoxId') {
                    clonedInput.value = '#sbxMobileSearch';
                }
                droneMenuSearch.appendChild(clonedInput);
            });

        // set up autocomplete functionality on request rather than on load for performance reasons
        windowScope.enableAutocomplete = () => {
            //@ts-ignore
            if (typeof window.SearchBoxFired === typeof undefined) {
                (function (document, tag) {
                    // load SearchBox which in turn loads jquery, only fired when search box is triggered by user
                    let ele = document.querySelector('[data-script="search-box"]');
                    if (ele) {
                        let src = ele.getAttribute('data-src');
                        if (src) {
                            ele.setAttribute('src', src);
                        }
                    }
                }(document, 'script'));
            }
        };

        // open search
        windowScope.openSearch = () => {
            windowScope.enableAutocomplete();
            windowScope.Bod?.classList.toggle('dim');
            windowScope.Bod?.classList.toggle('search-active');
            if (windowScope.Bod?.classList.contains('search-active')) {
                windowScope.Bod?.classList.add('disable-main-nav'); // temporarily disable nav after revealing search box to stop mega nav getting in the way
                if (window.matchMedia('(min-width: 992px)').matches) {
                    const focusableInput = document.querySelector('.sbx-search-box [data-main-search-input]') as HTMLInputElement;
                    focusableInput.focus();
                }
            }
            else {
                windowScope.Bod?.classList.remove('disable-main-nav');
            }
            windowScope.closeMobNav(false);

            const searchBox = document.querySelector('.sbx-main-search-field-wrp') as HTMLElement;
            if (searchBox !== null) {
                searchBox.addEventListener('mouseenter', function () {
                    windowScope.Bod?.classList.remove('disable-main-nav');
                });
            }
        };
    }
}
